export enum AccountTypes {
  EMPTY = '',
  ESTATE = 'ESTATE',
  EXECUTOR_ESTATE = 'EXECUTOR_ESTATE',
  INDIVIDUAL = 'INDIVIDUAL',
  INDV = 'INDV',
  IRA = 'IRA',
  JOINT = 'JOINT',
  JOINT_COMMUNITY_PROPERTY = 'JOINT_COMMUNITY_PROPERTY',
  JOINT_TENANTS_WROS = 'JOINT_TENANTS_WROS',
  ORG = 'ORG',
  ENDOWMENT = 'ENDOWMENT',
  HOSPITAL = 'HOSPITAL',
  SCHOOL_DISTRICT = 'SCHOOL_DISTRICT',
  PARTNERSHIP = 'PARTNERSHIP',
  CORPORATION_BANKRUPTCY = 'CORPORATION_BANKRUPTCY',
  CORPORATION = 'CORPORATION',
  IIG_CORPORATION = 'IIG_CORPORATION',
  EXEMPT_UNINCORPORATED_ORGANIZATION = 'EXEMPT_UNINCORPORATED_ORGANIZATION',
  FOUNDATION = 'FOUNDATION',
  NONEXEMPT_UNINCORPORATED_ORGANIZATION = 'NONEXEMPT_UNINCORPORATED_ORGANIZATION',
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  PROFESSIONAL_ASSOCIATION = 'PROFESSIONAL_ASSOCIATION',
  PROFESSIONAL_CORPORATION = 'PROFESSIONAL_CORPORATION',
  PROFESSIONAL_CORPORATION_ASSOCIATION = 'PROFESSIONAL_CORPORATION_ASSOCIATION',
  OTHER = 'OTHER',
  TRUST = 'TRUST',
  UGMA_UTMA = 'UGMA_UTMA',
}

export enum AccountTypeNames {
  EMPTY = '',
  EXECUTOR_ESTATE = 'Estate',
  ESTATE = 'Estate',
  INDIVIDUAL = 'Individual',
  INDV = 'Individual',
  IRA = 'IRA',
  JOINT = 'Joint',
  JOINT_TENANTS_WROS = 'Joint',
  ORG = 'Organization',
  ENDOWMENT = 'Endowment',
  HOSPITAL = 'Hospital',
  SCHOOL_DISTRICT = 'Organization',
  PARTNERSHIP = 'Partnership',
  CORPORATION_BANKRUPTCY = 'Corporation',
  CORPORATION = 'Corporation',
  IIG_CORPORATION = 'Corporation',
  EXEMPT_UNINCORPORATED_ORGANIZATION = 'Organization',
  FOUNDATION = 'Foundation',
  NONEXEMPT_UNINCORPORATED_ORGANIZATION = 'Organization',
  SOLE_PROPRIETORSHIP = 'Sole Proprietorship',
  PROFESSIONAL_ASSOCIATION = 'Organization',
  PROFESSIONAL_CORPORATION = 'Organization',
  PROFESSIONAL_CORPORATION_ASSOCIATION = 'Organization',
  OTHER = 'Other',
  TRUST = 'Trust',
  UGMA_UTMA = 'UGMA/UTMA',
}
